import { useLocation } from "react-router";

import LogoIcon from "@/components/common/LogoIcon";
import { isEntryActive, MAIN_NAV } from "@/components/layout/navigation";

export default function MobileHeader() {
  const { pathname } = useLocation();
  const current = MAIN_NAV.find((entry) => isEntryActive(pathname, entry));

  return (
    <header className="md:hidden sticky top-0 z-20 flex h-14 items-center gap-2 border-b border-border bg-card px-4">
      <LogoIcon size={26} primaryColor="var(--nafa-black)" secondaryColor="var(--nafa-yellow)" />
      <span className="text-base font-semibold">{current?.label ?? "Nafa Pro"}</span>
    </header>
  );
}
